import { render, staticRenderFns } from "./CalculatingChildSupport.vue?vue&type=template&id=94958af8"
import script from "./CalculatingChildSupport.vue?vue&type=script&lang=ts"
export * from "./CalculatingChildSupport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports